<template>
  <el-date-picker
    class="demo"
    v-model="value"
    type="datetime"
    :placeholder="placeholder"
    :format="format"
    :value-format="valueFormat"
    :disabled="disabled"
    :clearable="clearable"
    :picker-options="setMonthDisabled"
    @change="change"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: 'DateTimePicker',
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
      default: '选择日期',
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss',
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showAfterDate: {
      type: String,
    },
    showBeforeDate: {
      type: String,
    },
  },
  computed: {
    setMonthDisabled() {
      return {
        disabledDate: (time) => {
          if (this.showAfterDate) {
            const after =
              new Date(time).getTime() - new Date(this.showAfterDate).getTime();
            return after < 0;
          } else if (this.showBeforeDate) {
            const before =
              new Date(time).getTime() -
              new Date(this.showBeforeDate).getTime();
            return before > 0;
          }
          return false;
        },
      };
    },
  },
  data() {
    return {};
  },
  methods: {
    focus() {
      // this.$nextTick(() => {
      //   const nodes =
      //     document.getElementsByClassName('el-month-table')[0].childNodes[0]
      //       .childNodes;
      //   const d1 = nodes[0].cells[0].childNodes[0].childNodes[0];
      //   d1.setAttribute('style', 'color: red');
      //   console.log(d1);
      // });
    },
    change(val) {
      this.$emit('input', val || []);
    },
  },
};
</script>
